import React from "react";
import { motion } from "framer-motion";
import { Mail, Stethoscope, Wrench } from "lucide-react";
import { team } from "../data/products";
import { WhatsAppIcon } from "./NavIcons";

const icons = { 0: Stethoscope, 1: Wrench };

const WHATSAPP_MESSAGE =
  "Hi! I found MedEase Nepal and I'm interested in your products. Could you please help me with more details?";

const buildWhatsAppLink = (number) =>
  `https://wa.me/${number}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export default function ContactSection({ refProp }) {
  return (
    <section className="contact-section" ref={refProp} id="contact">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="section-eyebrow">OUR EXPERTS</div>
          <h2 className="section-title">Meet the <em>Specialists</em></h2>
          <p className="section-sub">Expert guidance from medical and engineering professionals</p>
        </motion.div>

        <div className="team-grid">
          {team.map((member, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={member.name}
                className="team-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15, duration: 0.8 }}
              >
                {member.image ? (
                  <div className="team-photo-wrap">
                    <img src={member.image} alt={member.name} className="team-photo" />
                  </div>
                ) : (
                  <div className="team-icon-wrap">
                    <Icon size={32} strokeWidth={1} />
                  </div>
                )}
                <h3 className="team-name">{member.name}</h3>
                <div className="team-role">{member.role}</div>
                <p className="team-bio">{member.bio}</p>
                <div className="team-expertise">
                  {member.expertise.map((e) => (
                    <span key={e} className="expertise-tag">{e}</span>
                  ))}
                </div>
                <div className="team-actions">
                  {member.whatsapp && (
                    <a
                      className="team-btn team-btn--whatsapp"
                      href={buildWhatsAppLink(member.whatsapp)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <WhatsAppIcon size={16} /> WhatsApp
                    </a>
                  )}
                  {i === 1 && (
                    <button className="team-btn">
                      <Mail size={14} /> Email
                    </button>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Contact info strip */}
        <motion.div
          className="contact-strip"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <div className="contact-item">
            <span className="contact-label">PHONE</span>
            <a href="tel:+9779716886567" className="contact-value">+977 971-688-6567</a>
          </div>
          <div className="contact-divider" />
          <div className="contact-item">
            <span className="contact-label">WEBSITE</span>
            <span className="contact-value">www.medeasenepal.com.np</span>
          </div>
          <div className="contact-divider" />
          <div className="contact-item">
            <span className="contact-label">AVAILABILITY</span>
            <span className="contact-value">WhatsApp & Email Consultation</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
